export default {
  START_LOADING({ commit }, name) {
    commit('START_LOADING', name)
  },
  END_LOADING({ commit }, name) {
    commit('END_LOADING', name)
  }
}
